import React from 'react'
import { TR, Info, MainSection, Actions, TH } from './styles'

interface Props {
  data: any
  showAction: boolean
}

const Head: React.FC<Props> = ({ data, showAction }) => (
  <TR>
    <Info>
      <MainSection>
        {data.map((item: any) => (
          <TH key={item.name} active={false}>
            <span>{item.name}</span>
            {/*<span>*/}
            {/*  <ChevronDownIcon />*/}
            {/*</span>*/}
          </TH>
        ))}
      </MainSection>
    </Info>
    {showAction && <Actions />}
  </TR>
)

export default Head
